import { TableCell, TableRow, Tooltip } from '@mui/material'
import React from 'react'
import { currencyText } from '../../../../../helpers/unitMeasure/UnitMeasureHelper'
import { useSelector } from 'react-redux'

const SupplyBillItemShort = ({ supplyBillItem, index, checked, setChecked }) => {

    const unitMeasures = useSelector(state => state.settings.unitMeasures)
    const unitMeasure = unitMeasures && unitMeasures[supplyBillItem.unitMeasure] ? unitMeasures[supplyBillItem.unitMeasure].name : '?'

  return (
    <TableRow>
        {/* <MyTableCheckBox 
            id={supplyOrderItem.id}
            checked={checked}
            setChecked={setChecked}
        /> */}
        <TableCell align='center'>
            <Tooltip title={`ID ${supplyBillItem.id}`}>
                {
                    index + 1
                }
            </Tooltip>
        </TableCell>
        <TableCell align='center' className='wordBreakAll'>
            {
				supplyBillItem.nameInBill ? supplyBillItem.nameInBill : supplyBillItem.name + ' (з заявки)'
			}
        </TableCell>
        <TableCell align='center'>
            {
                // supplyBillItem.count + ' ' + unitMeasureShortText[supplyBillItem.unitMeasure]
                supplyBillItem.count + ' ' + unitMeasure
            }
        </TableCell>
         <TableCell align='center'>
            {
                supplyBillItem.pdvType === 'withoutPdv' && supplyBillItem.priceWithPdv 
                ?
                    `${supplyBillItem.priceWithPdv.one ? supplyBillItem.priceWithPdv.one.toLocaleString('ru') : 0} / ${supplyBillItem.priceWithPdv.general ? supplyBillItem.priceWithPdv.general.toLocaleString('ru') : 0}`
                :
                    `${supplyBillItem.priceOne ? supplyBillItem.priceOne.toLocaleString('ru') : 0} / ${supplyBillItem.priceGeneral ? supplyBillItem.priceGeneral.toLocaleString('ru') : 0}`
            }
            {
                ' '
            }
            {
                currencyText[supplyBillItem.currency]
            }
        </TableCell>
    </TableRow>
  )
}

export default SupplyBillItemShort